import React from 'react'
import { BarChart3, Mail, Calendar } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  // Smooth scroll handler for contact section
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-white border-t border-border-color py-12">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/tagnetica-badge.webp" alt="Tagnetica logo" className="h-8 w-8 object-contain rounded-lg p-1" />
              <span className="text-xl font-bold text-text-primary">Tagnetica</span>
            </div>
            <p className="text-text-secondary leading-relaxed">
              Expert analytics and tag management consulting. Making your data reliable, 
              your tracking complete, and your reporting work.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold text-text-primary mb-4">Services</h4>
            <ul className="space-y-2">
              <li className="text-text-secondary">Google Tag Manager Setup</li>
              <li className="text-text-secondary">GA4 Implementation</li>
              <li className="text-text-secondary">Matomo Configuration</li>
              <li className="text-text-secondary">Analytics Audits</li>
              <li className="text-text-secondary">Conversion Tracking</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-semibold text-text-primary mb-4">Get In Touch</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-primary" />
                <button
                  onClick={scrollToContact}
                  className="text-text-secondary hover:text-primary underline transition-colors bg-transparent border-none p-0 m-0 cursor-pointer"
                  style={{ font: 'inherit' }}
                  type="button"
                >
                  Send us a message
                </button>
              </div>
              <div className="flex items-center gap-3">
                <Calendar className="h-5 w-5 text-primary" />
                <button
                  onClick={scrollToContact}
                  className="text-text-secondary hover:text-primary underline transition-colors bg-transparent border-none p-0 m-0 cursor-pointer"
                  style={{ font: 'inherit' }}
                  type="button"
                >
                  Book a free consultation
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-border-color mt-8 pt-8 text-center">
          <p className="text-text-secondary">
            © 2024 Tagnetica. All rights reserved. •{" "}
            <Link to="/privacy-policy" className="text-text-secondary hover:text-primary underline transition-colors">
              Privacy Policy
            </Link>{" "}
            •{" "}
            <Link to="/terms-conditions" className="text-text-secondary hover:text-primary underline transition-colors">
              Terms of Service
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
